import { Component, Input } from '@angular/core';
import { AbstractValueAccessor } from '../../utils/AbstractValueAccessor';
import { valueAccessorProvider } from '../../utils/provider-builders';

@Component({
  selector: 'radio-button-block',
  template: `
    <div class="flex__container">
      @for(choice of choices; track $index) {
      <radio-button-box
        class="display--block radio-button-box"
        [ngClass]="{ selected: model === choice.value }"
        [text]="choice.label"
        [(ngModel)]="model"
        [value]="choice.value"
        [disabled]="choice.disabled"
      ></radio-button-box>
      }
    </div>
    <div class="radio-content__container" [ngClass]="{ 'first-item-active': model === choices[0]?.value }">
      <div class="row-wrapper">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./radio-button-block.component.scss'],
  providers: [valueAccessorProvider(RadioButtonBlock)],
  standalone: false,
})
export class RadioButtonBlock<T> extends AbstractValueAccessor<T> {
  @Input() choices: Array<RadioButtonBlockChoice<T>> = [];
}

export interface RadioButtonBlockChoice<T> {
  value: T;
  label: string;
  disabled?: boolean;
}
